module.exports = __webpack_public_path__ + "media/bootstrap-icons/door-closed-fill-725b5df0.svg";